<template>
  <div>
    <p>aaa</p>
  </div>
</template>

<script>

export default {
  name: 'HomeView',

  components: {
    
  },
}
</script>
